/**
 * Sidebar active-item matching.
 * Prefers the most specific path so /erp/accounting does not also highlight /erp.
 */

/** True when pathname is exactly base or a nested route under base (not a sibling prefix). */
export function pathIsUnder(pathname, base) {
  if (!base || !pathname) return false;
  return pathname === base || pathname.startsWith(`${base}/`);
}

/**
 * Return match score for a menu item (0 = no match). Higher = more specific.
 */
export function menuItemMatchScore(item, pathname, searchParams) {
  const crmTab = searchParams.get('tab');
  if (item.path === '/crm') {
    return pathname === '/crm' && crmTab !== 'pipeline' ? item.path.length : 0;
  }
  if (item.path === '/crm?tab=pipeline') {
    if ((pathname === '/crm' && crmTab === 'pipeline') || pathname === '/crm-pipeline') {
      return '/crm?tab=pipeline'.length;
    }
    return 0;
  }
  if (item.matchPaths?.length) {
    let best = 0;
    for (const p of item.matchPaths) {
      if (pathIsUnder(pathname, p)) best = Math.max(best, p.length);
    }
    return best;
  }
  const itemPath = String(item.path || '').split('?')[0];
  if (itemPath === '/') return pathname === '/' ? 1 : 0;
  return pathIsUnder(pathname, itemPath) ? itemPath.length : 0;
}

export function resolveActiveMenuPath(menuItems, pathname, search = '') {
  const params = new URLSearchParams(search);
  let bestPath = null;
  let bestScore = 0;
  for (const item of menuItems) {
    const score = menuItemMatchScore(item, pathname, params);
    if (score > bestScore) {
      bestScore = score;
      bestPath = item.path;
    }
  }
  return bestPath;
}
